(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primori-product-list-test"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('primori-test-recommendations')) {
    customElements.define('primori-test-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || !this.dataset.url) return;
        this.dataset.loaded = 'true';
        this.loadRecommendations();
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) throw new Error('Recommendations request failed');
          const html = await response.text();
          if (!this.isConnected) return;
          const document = new DOMParser().parseFromString(html, 'text/html');
          const result = Array.from(document.querySelectorAll('primori-test-recommendations'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          if (!result || result.hidden || !result.querySelector('.resource-list__item')) return;
          this.innerHTML = result.innerHTML;
          this.hidden = false;
        } catch (error) {
          console.warn('Primori recommendations could not be loaded.', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
